/**
 * 预算单位路由表
 */
import UserConsoleLayout from '@/views/kpi/layout/userConsoleLayout.vue';

/**
 * @import {Route} from "./route.jsdoc.js"
 */

/**
 * 预算单位路由表
 * @type {[Route]}
 */
export const budgetRoutes = [
    {
        title: '项目绩效申报表',
        path: '/kpi/proj-kpi/declare/proj-list',
        page: () => import('@/views/kpi/kpi-build/proj-kpi/proj-kpi-list.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效全过程', '项目绩效申报表' ],
        icon: [ 'vxe-icon-folder', '' ],
    },
    {
        title: '项目绩效监控',
        path: '/kpi/proj-kpi/monitor/proj-list',
        page: () => import('@/views/kpi/kpi-monitor/proj-monitor/proj-kpi/proj-kpi.vue'),
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        history: true,
        closable: true,
        menu: [ '绩效全过程', '项目绩效监控' ],
        icon: [ 'vxe-icon-folder', '' ],
    },
    {
        title: '项目绩效自评',
        path: '/kpi/proj-kpi/appraise/proj-list',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/scoring/index.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效全过程', '项目绩效自评' ],
        icon: [ 'vxe-icon-folder', '' ],
    },
    {
        title: '项目绩效监控清单',
        path: '/kpi/proj-kpi/monitor/pro-monitor-list/:projId',
        page: () => import('@/views/kpi/kpi-monitor/proj-monitor/kpi-monitor-list/kpi-monitor-list.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '项目绩效监控表',
        path: '/kpi/proj-kpi/monitor/monitor-detail/:pmId',
        page: () => import('@/views/kpi/kpi-monitor/proj-monitor/kpi-monitor/kpi-monitor.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '项目绩效自评',
        path: '/kpi/proj-kpi/appraise/appraise-home',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/home/appraise-home.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '绩效自评表查阅',
        path: '/kpi/proj-kpi/appraise/scoring-detail/:id',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/scoring/scoring.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '绩效自评权重设置',
        path: '/kpi/proj-kpi/appraise/weight-setting-detail/:id',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/weight-setting/weight-setting.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        path: '/kpi/proj-kpi/appraise/weight-setting',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/weight-setting/index.vue'),
        layout: [ UserConsoleLayout ],
        title: '绩效自评表权重设置',
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
];
